<template>

    <div>
        <form class="myForm mt-5">
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Obra:<span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <div id="combo_obras"></div>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Data: <span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtRef"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData"
                    ></datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Tipo de Serviço:<span
                        class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <div id="combo_servicos"></div>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Detalhe do Serviço:</label>
                <div class="col-sm-4">
                    <textarea class="form-control" v-model="detServico" rows="3"></textarea>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Fiscal:</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="fiscal">
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Responsável:</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="responsavel">
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Perc. de Execução: <span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <the-mask type="text" class="form-control" v-model="percExec" :mask="'#########'"/>
                </div>
            </div>

        </form>
        <hr>
        <br>
        <br>
        <h6>Adicionar fotos da medição:</h6>
        <br>
        <div class="row">
            <div class="col-6">
                <vue-dropzone id="drop1" :options="dropOptions" ref="myVueDropzone"
                              v-on:vdropzone-success="dropzoneCallback"></vue-dropzone>
            </div>
            <div class="col-6">
                <label>Descrição</label>
                <textarea class="form-control" rows="3" v-model="desc"></textarea>
                <br>
                <button class="btn btn-sm btn-primary" @click="adicionar" :disabled="!imagemTmp != '' || !desc != ''">Adicionar</button>
            </div>
        </div>
        <br>
        <br>
        <br>
        <div v-if="imagem != ''">
            <table class="table">
                <tr>
                    <td>Imagem</td>
                    <td>Descrição</td>
                    <td>Ações</td>
                </tr>
                <tbody>
                <tr v-for="(imagens, i) in imagem" :key="i">
                    <td><img :src="imagens.src"></td>
                    <td>{{imagens.descr}}</td>
                    <td>
                        <button class="btn btn-sm btn-danger" title="Excluir" @click="eliminar(i)"><i
                                class="fas fa-trash"></i></button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2"
                :disabled="(!dtRef != '' || !obrasSel != '' || !servicosSel != '' || !percExec != '' || img == true)"
                @click="salvar">Salvar
            </button>
        </div>

    </div>
</template>

<script>
    import MenuInterno from '../menu-interno/MenuInterno.vue'
    import vueDropzone from "vue2-dropzone"
    import Datepicker from 'vue2-datepicker'

    var comboObras, comboTpServicos, uploadFoto, uploadCampo;


    export default {
        name: 'MedicoesCadastro',
        components: {
            MenuInterno,
            vueDropzone,
            Datepicker
        },
        data() {
            return {
                medObra: '',
                dtRef: '',
                servicos: '',
                detServico: '',
                fiscal: '',
                responsavel: '',
                percExec: '',
                obrasSel: '',
                servicosSel: '',
                desc: '',
                imageData: '',
                imagemTmp: '',
                dropOptions: {
                    url: axios.defaults.baseURL + "/api/sist-obras/medicoes/upload-img",
                    thumbnailWidth: 120,
                    thumbnailHeight: 120,
                    dictDefaultMessage: "<i class='fas fa-cloud-upload-alt'></i> <br>Clique aqui para enviar uma foto",
                    addRemoveLinks: true,
                    maxFiles: 1,
                    headers: {
                        'Authorization': 'Bearer '+Store.getters.pegaAccessToken
                    }
                },
                imagem: [],
                lang: {
                    days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                    months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    pickers: ['próximos 7 dias', 'próximos 30 dias', '7 dias atrás', '30 dias atrás'],
                    placeholder: {
                        date: 'Selecione uma Data',
                        dateRange: 'Selecione um range de Datas'
                    }
                },
                img: false
            }
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            formataData(dt){
                return new Date(dt).toLocaleDateString('ko-KR', {
                    year : 'numeric',
                    month : '2-digit',
                    day : '2-digit'
                }).split('. ').join('-').replace('.','');
            },
            adicionar() {
                this.imagemTmp.descr = this.desc
                this.desc = ''
                this.imagemTmp.src = $('.dz-image img').attr('src')
                this.$refs.myVueDropzone.removeAllFiles()
                this.imagem.push(this.imagemTmp)
                this.img = false
            },
            eliminar(i) {
                this.imagem.splice(i, 1)
            },
            dropzoneCallback(file, response) {
                this.imagemTmp = {img: response, descr: '', src: ''}
                this.img = true
            },
            validaData(){
                if(new Date(this.dtRef).getTime() > Date.now()){
                    this.dtRef = '';
                    this.$swal('Atenção!', 'A data da medição deve ser menor que a data atual', 'error')
                }
            },
            salvar() {
                API.enviarRequisicao('post', '/api/sist-obras/medicoes', {
                    o03_refer: this.formataData(this.dtRef),
                    o03_descr_serv: this.detServico,
                    o03_fiscal_obra: this.fiscal,
                    o03_respons_tecnico: this.responsavel,
                    o03_medicao_percent: this.percExec,
                    o03_obra_id: this.obrasSel,
                    o03_tpservico_id: this.servicosSel,
                    o02_path_img: this.imagem
                })
                    .then(response => {
                        this.$swal('Atenção!', 'Dados salvos com sucesso.', 'success')
                            .then(
                                function () {
                                    history.go(0);
                                }
                            )
                    })
                    .catch(function (error) {
                        this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'error')
                    })
            },


        },
        mounted: function () {

            let that = this;

            API.enviarRequisicao('get', '/api/sist-obras/obras/obterCombo/dhtmlx/obras')
                .then(response => {
                    this.medObra = response.data
                    comboObras = new dhtmlXCombo("combo_obras");
                    comboObras.load(this.medObra, "json");
		            comboObras.enableFilteringMode(true);
                    comboObras.attachEvent("onChange", function (value) {
                        that.obrasSel = value;
                    });
                }),
                API.enviarRequisicao('get', '/api/sist-obras/tipo-servicos/obterCombo/dhtmlx/tpServicos')
                    .then(response => {
                        this.servicos = response.data
                        comboTpServicos = new dhtmlXCombo("combo_servicos");
                        comboTpServicos.load(this.servicos, "json");
			            comboTpServicos.enableFilteringMode(true);
                        comboTpServicos.attachEvent("onChange", function (value) {
                            that.servicosSel = value;
                        });
                    });
        }
    }
</script>

<style scoped>

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

    .dz-clickable {
        width: 200px;
        height: 100px;
        padding: 0;
        color: #aaa;
        border-radius: 15px;
        text-align: center;
    }

    .dz-remove {
        margin-left: 0;
        border: none;
    }

    .mx-datepicker{
        width: 100%;
    }
</style>
